import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export const STAY_LOGGED_IN_STORAGE_KEY = 'ollaa_partner_stay_logged_in';

/** Default true: partner PWA should survive force-quit unless user opts out at login. */
export function readStayLoggedInPreference() {
  try {
    const raw = localStorage.getItem(STAY_LOGGED_IN_STORAGE_KEY);
    if (raw === '0') return false;
    if (raw === '1') return true;
  } catch {
    // localStorage unavailable
  }
  return true;
}

export function writeStayLoggedInPreference(stayLoggedIn) {
  try {
    localStorage.setItem(STAY_LOGGED_IN_STORAGE_KEY, stayLoggedIn ? '1' : '0');
  } catch {
    // ignore
  }
}

export async function applyLoginPersistence(stayLoggedIn) {
  writeStayLoggedInPreference(stayLoggedIn);
  const persistence = stayLoggedIn
    ? firebase.auth.Auth.Persistence.LOCAL
    : firebase.auth.Auth.Persistence.SESSION;
  await firebase.auth().setPersistence(persistence);
}

/** Align Firebase persistence with stored “Angemeldet bleiben” before auth restores. */
export function initDefaultAuthPersistence() {
  const persistence = readStayLoggedInPreference()
    ? firebase.auth.Auth.Persistence.LOCAL
    : firebase.auth.Auth.Persistence.SESSION;
  return firebase.auth().setPersistence(persistence).catch(() => {});
}
